document.addEventListener("DOMContentLoaded", function () {
  // Get the elements
  const skViewButton = document.getElementById("sk-view");
  const productGrid = document.getElementById("product-grid");
  const cardContents = document.querySelectorAll(
    ".card.card--standard.card--media > .card__content"
  );

  // Array of possible column classes
  const columnClasses = [
    "product-grid grid--1-col-tablet-down grid--3-col-desktop",
    "product-grid grid--2-col-tablet-down grid--4-col-desktop",
    "product-grid grid--3-col-tablet-down grid--6-col-desktop",
  ];

  // Initialize a counter to keep track of the current class
  let currentClassIndex = 1;

  // Function to switch grid columns
  function switchGridColumns() {
    // Remove all the column classes from the grid
    columnClasses.forEach((className) => {
      productGrid.classList.remove(...className.split(" "));
    });

    // Update the index to the next class in the array
    currentClassIndex = (currentClassIndex + 1) % columnClasses.length;
    updateBoxes(currentClassIndex);
    // Add the new column class
    productGrid.classList.add(...columnClasses[currentClassIndex].split(" "));
  }

  // Function to update the boxes based on the current index
  function updateBoxes(currentClassIndex) {
    // Get all the boxes
    const boxes = document.querySelectorAll(".box");

    // Loop through the boxes and set the class based on the index
    boxes.forEach((box, index) => {
      if (index <= currentClassIndex) {
        // If index is less than or equal to the current index, fill the box
        box.classList.add("filled");
        box.classList.remove("outlined");
      } else {
        // If index is greater than the current index, outline the box
        box.classList.add("outlined");
        box.classList.remove("filled");
      }
    });
  }
  // Initial state
  updateBoxes(currentClassIndex);
  // Attach event listener to the button
  skViewButton.addEventListener("click", switchGridColumns);
});
